module.exports = __webpack_public_path__ + "img/B低通25.4cc9b37b.png";